import { useNavigate } from "react-router-dom";

import bg from "./assets/background.jpeg";
import guide from "./assets/guide.png";
import institute from "./assets/campus.jpeg";
import logo from "./assets/logo.jpeg";

function Welcome() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        padding: "40px",
      }}
    >
      {/* Guide */}
      <img src={guide} alt="guide" style={{ height: "420px" }} />

      {/* Welcome Card */}
      <div
        style={{
          background: "rgba(255,255,255,0.85)",
          backdropFilter: "blur(10px)",
          padding: "40px",
          borderRadius: "20px",
          textAlign: "center",
          maxWidth: "420px",
        }}
      >
        <img src={logo} alt="logo" style={{ width: "70px" }} />
        <h2>Welcome to BCI 👋</h2>
        <p>Your AI mentor is here to guide you.</p>

        <p>
          Complete lessons, earn stars ⭐ and certificates 🎓
        </p>

        <button
          onClick={() => navigate("/lobby")}
          style={{
            marginTop: "20px",
            padding: "12px 30px",
            borderRadius: "30px",
            border: "none",
            background: "#4f46e5",
            color: "white",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Start Learning
        </button>
      </div>

      {/* Institute Image */}
      <img
        src={institute}
        alt="institute"
        style={{ height: "420px", borderRadius: "20px" }}
      />
    </div>
  );
}

export default Welcome;
